import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import * as AuthActions from '../../actions/auth.actions';
import { AuthSSO, ErrCode } from '../../shared/models';
import { Observable ,  Subscription } from 'rxjs';
import { LoggerService } from '../../core/logger.service';
import { DispatchService } from '../../core/dispatch.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'sync-sso',
    templateUrl: './sso.component.html',
    styleUrls: ['./sso.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class SsoComponent implements OnInit, OnDestroy {

    public errcode: ErrCode;
    public twofarequired: boolean;
    public twofacode: string;

    private subscription: Subscription;
    private lookUpKey: string;
    private password: string;

    private hasSubmitted: boolean;

    constructor(
        private dispatch: DispatchService,
        private store: Store<fromRoot.State>,
        private auth: AuthService,
        private log: LoggerService,
        private router: Router,
        private route: ActivatedRoute
    ) { }
    async ngOnInit() {
        await this.auth.logout();

        this.subscription = this.store
        .select(fromRoot.getAuthState)
        .subscribe((data) => {
            console.log(data);
            if (!this.hasSubmitted) {
                return;
            }
            if (data.twofarequired) {
                this.twofarequired = true;
                this.log.info('2FA is required to sign in to this account');
            }
            if (data && !data.authenticated && data.error) {
                this.hasSubmitted = false;
                this.log.warn(data.error);
                if (data.error.code === 9401) {
                    console.log('9401?!?!?!');
                    this.errcode = new ErrCode(8108);
                } else if (data.error.code == 8024) {
                    this.errcode = new ErrCode(8108);
                    this.twofacode = undefined;
                } else {
                    console.log('9401?!?!?!');
                    this.errcode = data.error;
                }
                this.log.e('Error signing in with SSO', this.errcode);
            }

            if (data.authenticated) {
                if (this.route.snapshot.queryParams['loc']) {
                    this.dispatch.run();
                } else if (this.route.snapshot.queryParams['return_to']) {
                    const path = decodeURIComponent(this.route.snapshot.queryParams['return_to']);
                    window.location.replace(path.substring(0, 1) == '/' ? path : `/${path}`);
                } else {
                    this.router.navigate(['/files'], { queryParams : undefined });
                    return;
                }
            }
        });
        const ssodata = this.route.snapshot.fragment;
        if (!ssodata) {
            this.log.error('No SSO data was provided in the hash');
            this.auth.logout();
            this.router.navigate(['/login'], { queryParams : undefined });
        }
        const hash = ssodata.split(',');
        this.lookUpKey = hash[0].replace('#', '');
        this.password  = hash[1];
        // console.log('Lookup ' + this.lookUpKey + ' password ' + this.password);
        if (!this.lookUpKey || !this.password) {
            this.log.error('Missing lookup key and/or password');
            this.auth.logout();
            this.router.navigate(['/login'], { queryParams : undefined });
        } else {
            this.hasSubmitted = true;
            const ssoData = new AuthSSO(this.lookUpKey, this.password, '');
            this.store.dispatch(new AuthActions.LoginSSOAction(ssoData));
            this.hasSubmitted = true;
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    public submit() {
        this.hasSubmitted = true;
        const ssoData = new AuthSSO(this.lookUpKey, this.password, this.twofacode);
        this.store.dispatch(new AuthActions.LoginSSOAction(ssoData));

    }
}
